import { PlatformEnum } from '@vacationtracker/shared/data/platforms'
import { SubscriptionPlan } from '@vacationtracker/shared/types/company'

export interface ICreateCompany {
  contactEmail?: string
  name?: string
  country?: string
  state?: string
  platform?: PlatformEnum
  plan?: SubscriptionPlan | null
  surveyQuestionMainOption?: string
  surveyQuestionSubOption?: string
}

export interface ICreateUser {
  name: string
  firstName?: string
  lastName?: string
  mail: string
  id?: string
  platform?: PlatformEnum
  tenantId?: string
  teamName?: string
  isOwner?: boolean
  isAdmin?: boolean
  slackBotToken?: string
  slackUserToken?: string
  slackTeamId?: string
  imageUrl?: string
  slackUserId?: string
  slackOrgTeamId?: string
  slackBotId?: string
  timezone?: string
  userName?: string
  userPassword?: string
  userRepeatPassword?: string
}

export interface ICreateCompanyState {
  createUser: ICreateUser
  createCompany: ICreateCompany
  currentStep: string
  isLoading: boolean
  isCreateCompanyLoader: boolean
  agreeToTerms: boolean
  flow: 'B_2025_06' | 'C_2025_06'
}

export enum CreateCompanyActionsEnum {
  setCurrentStep = 'SET_CURRENT_STEP',
  onNextStepChange = 'ON_NEXT_STEP',
  onPrevStepChange = 'ON_PREV_STEP',
  setCreateCompanyDetails = 'SET_CREATE_COMPANY_DETAILS',
  setAnnounceNewUsers = 'SET_ANNOUNCE_NEW_USERS',
  setCreateUser = 'SET_CREATE_USER',
  isCreateCompanyLoader = 'IS_CREATE_COMPANY_LOADER',
  setCreateUserName = 'SET_CREATE_USER_NAME',
  setFlow = 'SET_FLOW',
  setPlan = 'SET_PLAN',
}

export type SignupVariation = 'PLAN_ACCOUNT_USERS' | 'ACCOUNT_USERS_PLAN' | 'ACCOUNT_USERS' | 'NOT_SET'
